module.exports = __webpack_public_path__ + "static/media/doc.png";


//////////////////
// WEBPACK FOOTER
// ./src/doc.png
// module id = 1011
// module chunks = 0